<template>
  <v-card light class="pa-6 pa-md-12" color="white" max-width="calc(100vw - 48px)">
    <v-row class="mb-4">
      <v-col cols="12" md="5">
        <seo-v-img
          :src="optimizedImageURL(listData.heroImage, { maxWidth: 800 })"
          :lazy-src="getMetaData(listData.heroImage)['image-lazy-src']"
          :aspect-ratio="getAspectRatio(listData.heroImage)"
          width="100%"
          />
      </v-col>
      <v-col cols="12" md="7">
        <p class="text-h6 text-md-h4 text-uppercase font-family-heading strong-blue--text mb-4">{{listData.tag || 'IF!Workshop'}}</p>
        <seo-v-img
          v-if="listData.partnerImage"
          class="mb-4"
          :src="optimizedImageURL(listData.partnerImage, {maxWidth: 400})"
          width="30%"
          :lazy-src="getMetaData(listData.partnerImage)['image-lazy-src']"
          :aspect-ratio="getAspectRatio(listData.partnerImage)"
          />
        <p class="text-subtitle-1 text-md-h5 font-family-body font-weight-bold blue--text">{{hour}}</p>
        <h1 class="text-h5 text-md-h3 text-uppercase mb-8 strong-blue--text">{{listData.title}}</h1>
        <MarkdownBlock class="text-body-2 text-md-body-1 blue--text" v-if="listData.speakers" :text="listData.speakers" />
      </v-col>
    </v-row>
    <v-expansion-panels flat v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header hide-actions color="white" class="pa-0">
          <template v-slot:default="{ open }">
            <v-row align="center" justify="start">
              <v-col cols="auto" class="shrink" v-if="$vuetify.breakpoint.mdAndUp"><v-btn fab small dark depressed class="v-expansion-panel-header__icon mx-auto d-block"><v-icon color="white">mdi-chevron-down</v-icon></v-btn></v-col>
              <transition><v-col cols="auto" v-if="!open && $vuetify.breakpoint.mdAndUp">Learn More</v-col></transition>
              <transition>
                <v-col cols="auto" v-if="Workshop" class="text-right grow px-0 px-md-3">
                  <v-btn depressed rounded dark large :block="$vuetify.breakpoint.smAndDown" @click.native.capture.stop class="px-md-16 my-2 mx-0 mx-md-2 font-weight-semibold col col-auto" :disabled="!participationEnabled" :href="calendarAddLink" target="_blank" rel="nofollow"><CalendarIcon  class="mr-2 calendar-icon" />Add to Google Calendar</v-btn>
                  <v-btn depressed rounded dark large :block="$vuetify.breakpoint.smAndDown" @click.native.capture.stop="participationEnabled ? requestingParticipation = true : null" class="px-md-16 my-2 mx-0 mx-md-2 font-weight-semibold col col-auto" :disabled="!participationEnabled" >{{participationButtonLabel}}</v-btn>
                </v-col>
              </transition>
              <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown" class="py-0 px-0 px-md-3 mt-n5"><v-btn large block dark depressed rounded class="my-2 mx-0 mx-md-2 v-expansion-panel-header__icon"><v-icon color="white">mdi-chevron-down</v-icon> <span v-if="!open">Learn More</span></v-btn></v-col>
            </v-row>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="white" class="pt-8" >
          <v-row align="start" no-gutters>
            <template v-if="Workshop">
              <!-- <v-row align="center" justify="center" no-gutters>
                <v-btn depressed rounded dark x-large :block="$vuetify.breakpoint.smAndDown" class="px-md-16 ma-4 font-weight-semibold col col-auto" :disabled="!participationEnabled" @click="requestingParticipation = true">{{participationButtonLabel}}</v-btn>
                <v-btn depressed rounded dark x-large :block="$vuetify.breakpoint.smAndDown" class="px-md-16 ma-4 font-weight-semibold col col-auto" :disabled="!participationEnabled" :href="calendarAddLink" target="_blank" rel="nofollow"><CalendarIcon  class="mr-2 calendar-icon" />Add to Google Calendar</v-btn>
              </v-row> -->
              <v-row>
                <v-col v-if="Workshop.aboutDescription" cols="12" :lg="Workshop.speakerDescription ? 6: 12">
                  <h2 class="text-subtitle-2 mb-2 text-uppercase font-weight-bold blue--text">{{Workshop.leftColumnTitle || $root.siteSettings.defaultWorkshopLeftColumnTitle}}</h2>
                  <MarkdownBlock class="text-body-2 text-md-body-1 blue--text" :text="Workshop.aboutDescription" />
                </v-col>
                <v-col v-if="Workshop.speakerDescription" cols="12" lg="6">
                  <h2 class="text-subtitle-2 mb-2 text-uppercase font-weight-bold blue--text">{{Workshop.rightColumnTitle || $root.siteSettings.defaultWorkshopRightColumnTitle}}</h2>
                  <MarkdownBlock class="text-body-2 text-md-body-1 blue--text" :text="Workshop.speakerDescription" />
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-col cols="12">
                <v-skeleton-loader type="heading" class="mb-4"/>
                <v-skeleton-loader type="sentences" />
              </v-col>
            </template>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="requestingParticipation" max-width="600" v-if="Workshop" dark content-class="dialog-with-close-button">
      <v-btn @click="requestingParticipation = false" fab top right depressed dark absolute class="ma-0 mr-n11 transparent-bg"><v-icon large>mdi-close</v-icon></v-btn>
      <v-sheet class="pa-4 pa-md-8" >
        <div class="text-subtitle-1 blue--text text--darken-3">{{new Date(Workshop.startingAt).toLocaleDateString($language.current, { weekday: 'long', month: 'long', day: 'numeric' })}}</div>
        <div class="text-subtitle-1 blue--text text--darken-3 font-weight-bold">{{new Date(Workshop.startingAt).toLocaleTimeString($language.current, { hour: '2-digit', minute: '2-digit' })}}-{{new Date(Workshop.endingAt).toLocaleTimeString($language.current, { hour: '2-digit', minute: '2-digit' })}}</div>
        <div class="text-subtitle-2 text-uppercase  blue--text text--darken-3 mb-4">{{Workshop.topics[0] ? Workshop.topics[0].title : (Workshop.tag || 'IF!Workshop')}}</div>
        <h1 class="text-h5 mb-8 text-uppercase">{{Workshop.title}}</h1>
        <!-- <div class="text-subtitle-1" v-if="Workshop.speakers">With {{Workshop.speakers}}</div> -->
        <v-divider class="blue darken-3 mb-8" />
        <v-row no-gutters class="text-center" v-if="!userRequestedParticipationBefore">
          <v-col col="12" md="10" offset-md="1">
            <div class="text-body-1 blue--text text--darken-3">Max Number of Participants:</div>
            <div class="text-h4 font-weight-bold"><b>{{this.Workshop.maxParticipants}}</b></div>
            <div class="text-body-1 mb-8 blue--text text--darken-3">All workshops will be held on Google Meet.<br />Within 48 hours from the start you will receive the access link and the instructions through Google Calendar.</div>
            <v-form ref="form" v-model="participationRequestValid" action="javascript:void(0);">
              <div class="text-body-1 font-weight-bold mb-2">Please insert your email required to participate</div>
              <v-text-field block outlined label="Email" v-model="requestEmail" :rules="$root.auth.emailRules" required />
              <v-checkbox v-model="nameDisclaimerAccepted" required :rules="[v => v === true]">
                <div slot='label'>I agree to my name and surname being visible to all participants during the entire duration of the workshop. </div>
              </v-checkbox>
              <v-checkbox v-model="thirdPartiesDisclaimerAccepted" >
                <div slot='label'>I agree to the processing and dissemination of my data, including to third parties, to allow profiling activity and the sending of trade communications in the commercial, marketing and advertising sectors</div>
              </v-checkbox>
              <v-btn block depressed dark rounded light x-large type="submit" :loading="submitting" :disabled="submitting || !participationRequestValid" @click="submitParticipationRequest">Request participation</v-btn>
            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters class="text-center" v-else>
          <v-col cols="10" offset="1">
            <div class="text-h4 mb-8">Thank you! Your registration was successful!</div>
            <div class="text-body-1 mb-8 blue--text text--darken-3">48 hours before your workshop you will receive the link to the Google Meet room and all the instructions to access it.</div>
            <div class="text-body-1 mb-8">In case you changed your mind and you don't want to participate anymore, please let us know by clicking the button below</div>
            <v-btn block dark depressed rounded x-large :loading="submitting" :disabled="submitting" @click="deleteParticipationRequest">Cancel registration</v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-dialog>
  </v-card>
</template>

<script>
import { MarkdownBlock } from '@monogrid/vue-lib'
import GetWorkshop from '@/graphql/GetWorkshop.gql'
import CalendarIcon from '@/assets/img/google-calendar-icon.svg'
import CreateWorkshopParticipationRequest from '@/graphql/mutations/CreateWorkshopParticipationRequest.gql'
import DeleteWorkshopParticipationRequest from '@/graphql/mutations/DeleteWorkshopParticipationRequest.gql'
import find from 'lodash/find'
import { optimizedImageURL, getMetaData, getAspectRatio } from '@/services/OptimizedImage'

export default {
  name: 'WorkshopBigCard',
  components: {
    MarkdownBlock,
    CalendarIcon
  },
  data () {
    return {
      panel: null,
      participationRequestValid: false,
      requestingParticipation: false,
      nameDisclaimerAccepted: false,
      thirdPartiesDisclaimerAccepted: false,
      submitting: false,
      requestEmail: null,
      signupOnOpen: false
    }
  },
  props: {
    listData: {
      type: Object,
      required: true
    }
  },
  // watch: {
  //   panel (value) {
  //     if (this.panel !== 0 && this.Workshop && this.signupOnOpen && this.participationEnabled) {
  //       this.requestingParticipation = true
  //     }
  //     this.signupOnOpen = false
  //   }
  // },
  computed: {
    userParticipationRequest () {
      if (this.Workshop) {
        return find(this.$root.databaseUser._referents.WorkshopParticipationRequestReferents.items, { workshop: { id: this.Workshop.id } })
      }
      return null
    },
    userRequestedParticipationBefore () {
      return !!this.userParticipationRequest
    },
    participationButtonLabel () {
      // label is always "Manage" for user who requested participation
      if (this.userRequestedParticipationBefore) {
        return 'Manage registration'
      }
      if (!this.participationEnabled) {
        if (this.Workshop) return this.Workshop.participationButtonLabel || 'SOLD OUT'
        return '...'
      }
      return this.Workshop.participationButtonLabel || this.$root.siteSettings.defaultParticipationButtonLabel
    },
    participationEnabled () {
      if (this.Workshop) {
        // button is always enabled for user who requested participation
        // they can request to be deleted through it
        if (this.userRequestedParticipationBefore) {
          return true
        }
        const isInFuture = this.$root.getNow().getTime() < new Date(this.Workshop.startingAt).getTime()

        const autoClosed = this.Workshop.participationAutomaticallyClosed && this.Workshop._referents.WorkshopParticipationRequestReferents.totalCount >= this.Workshop.maxParticipants

        return isInFuture &&
          // !this.userRequestedParticipationBefore &&
          this.Workshop.participationEnabled &&
          !autoClosed
      }
      return false
    },
    calendarAddLink () {
      const sd = new Date(this.listData.startingAt).toISOString().replace(/(-|:|\.000Z)/g, '')
      const ed = new Date(this.listData.endingAt).toISOString().replace(/(-|:|\.000Z)/g, '')
      return `https://calendar.google.com/calendar/r/eventedit?text=${encodeURIComponent(this.listData.title)}&dates=${sd}/${ed}&ctz=Etc/GMT&details=${encodeURIComponent(this.listData.aboutDescription)}`
    },
    hour () {
      const start = new Date(this.listData.startingAt).toLocaleTimeString(this.$language.current, { hour: 'numeric', minute: 'numeric' })
      const end = new Date(this.listData.endingAt).toLocaleTimeString(this.$language.current, { hour: 'numeric', minute: 'numeric' })
      const date = new Date(this.listData.endingAt).toLocaleDateString(this.$language.current, { month: 'long', day: 'numeric' })

      return `${start} - ${end}, ${date}`
    }
  },
  methods: {
    optimizedImageURL,
    getMetaData,
    getAspectRatio,
    async deleteParticipationRequest () {
      this.submitting = true
      try {
        await this.$apollo.mutate({
          mutation: DeleteWorkshopParticipationRequest,
          variables: {
            id: this.userParticipationRequest.id
          }
        })
      } catch (e) {
        console.error(e)
      }
      this.submitting = false
    },
    async submitParticipationRequest () {
      if (this.$refs.form.validate()) {
        this.submitting = true
        try {
          await this.$apollo.mutate({
            mutation: CreateWorkshopParticipationRequest,
            variables: {
              input: {
                googleEmail: this.requestEmail,
                user: `_reference/User/${this.$root.databaseUser.id}`,
                workshop: `_reference/Workshop/${this.Workshop.id}`,
                nameDisclaimerAccepted: this.nameDisclaimerAccepted,
                thirdPartiesDisclaimerAccepted: this.thirdPartiesDisclaimerAccepted
              }
            }
          })
        } catch (e) {
          console.error(e)
        }
        this.submitting = false
      }
    }
  },
  apollo: {
    Workshop: {
      query: GetWorkshop,
      // skip () {
      //   return this.panel !== 0
      // },
      variables () {
        return {
          status: 'PUBLISHED',
          id: this.listData.id
        }
      },
      result () {
        // if (this.signupOnOpen && this.participationEnabled) {
        //   this.requestingParticipation = true
        //   this.signupOnOpen = false
        // }
        // this.$root.$emit('scroll-to-saved-position')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-icon {
  width: 30px;
  height: 30px;
}

.v-card {
  box-shadow: 6px 6px 0 3px map-deep-get($colors, 'strong-blue', 'base') !important;
}

.v-btn--has-bg {
  &.transparent-bg {
    &.theme--dark {
      background-color: rgba(map-get($material-dark, 'app-bar'), 0.5);
    }

    &.theme--light {
      background-color: rgba(map-get($material-light, 'app-bar'), 0.5);
    }
  }

}

.app .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: #0091d7 !important;
  opacity: 0.5;
}
</style>
